import React from "react";

import Dashboard from "../../client_config/ppc_config/video/dashboard/Dashboard";

export default function Video(props) {
  return (
    <div style={{ backgroundColor: "#F5F5F5" }}>
      <Dashboard {...props} onboarding />
    </div>
  );
}
